import React, { useState } from 'react';
import '../styles/LoginScreen.css';
import '../i18n';
import { LoginView } from './features/login/LoginView';

export const LoginScreen: React.FC = () => {
    const [error, setError] = useState<string | null>(null);

    return (
        <div className="login-screen" style={{ paddingLeft: "0.5em", paddingRight: "0.5em" }}>
            {/* <img src="/logo.png" alt="App Logo" className="app-logo" /> */}
            <h1>Schatzmeister Toolsbox, <br />erstmal einloggen</h1>
            {error && (
                <div className="error-box">
                    {error}
                </div>
            )}
            <LoginView setError={setError} />
        </div>
    );
};